import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import SupplierTable from '../../components/SupplierTable/SupplierTable';
import './Supplier.scss';

const Supplier = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateSupplier = () => {
    navigate('/suppliers/create');
  };

  return (
    <div className="supplier-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('suppliers')}</div>
        <SupplierTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateSupplier}
        title={t('createSupplier')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default Supplier; 